module.exports = __webpack_public_path__ + "static/img/integral_click_nianhuo@2x.ec3b211b.png";